import { render } from "./Boardcast.vue?vue&type=template&id=df18ff3a&scoped=true"
import script from "./Boardcast.vue?vue&type=script&lang=js"
export * from "./Boardcast.vue?vue&type=script&lang=js"

import "./Boardcast.vue?vue&type=style&index=0&id=df18ff3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df18ff3a"]])

export default __exports__